<app-work-order-filter-bar
  [isDayView]="selectedView == 'day'"
  [typeOfWorkOrders]="isWellnessOnly ? 'wellness' : 'work'"
  [allWorkOrders]="isWellnessOnly ? wellnessWorkOrders : workWorkOrders"
  [rms]="rms"
  [equipmentTypes]="equipmentTypes"
  (OnWoFilteringFinished)="OnWoFilteringFinished($event)"
  [useSearchDelay]="false"
  >
</app-work-order-filter-bar>

<div class="showColorBar">
  <span style="float: left">
    @if (timerPaused) {
      <i class="fa fa-play"  (click)="startTimer()"></i>
    }
    @if (!timerPaused) {
      <i class="fa fa-pause" (click)="pauseTimer()"></i>
    }
    {{timeLeft | time}} until refresh
  </span>
  @if (selectedView == 'day') {
    <span>Show Zip Code Colors</span>
  }
  @if (selectedView == 'week') {
    <span>Zip</span>
  }
  <p-checkbox binary="true" name="shouldShowLeftColor" [(ngModel)]="shouldShowLeftColor"></p-checkbox>
  @if (selectedView == 'day') {
    <span>Show Priority Colors</span>
  }
  @if (selectedView == 'week') {
    <span>Priority</span>
  }
  <p-checkbox binary="true" name="shouldShowRightColor" [(ngModel)]="shouldShowRightColor"></p-checkbox>
</div>

@if (isWellnessOnly) {
  <div
    class="p-grid"
    id="workOrdersPanelList"
    cdkDropList
    [cdkDropListDisabled]="!canDrag"
    [cdkDropListData]="filteredWellnessWorkOrders"
    [cdkDropListConnectedTo]="dragAndDropService.allCDKWorkOrderListIds"
    (cdkDropListDropped)="drop($event)"
    cdkDropListSortingDisabled="true">
    @if (isLoadingWOs) {
      <div>
        <i class="pi pi-spin pi-spinner" style="font-size: 3em"></i>
      </div>
    }
    @if (!isLoadingWOs && filteredWellnessWorkOrders.length == 0) {
      <div>
        No wellness work orders to schedule at this time.
      </div>
    }
    @for (workOrder of filteredWellnessWorkOrders; track workOrder; let i = $index) {
      @if (i < 30 || showAllWellness) {
        <app-wellness-work-order-card
          [ngClass]="{'custom-p-col-lg p-md-4 p-sm-6': selectedView == 'day', 'p-col-12': selectedView == 'week'}"
          [workOrder]="workOrder"
          [showScheduled]="false"
          [showMap]="false"
          (dragStartEvent)="taskDragged($event)"
          (taskDragEndEvent)="taskDragEnd()"
          cdkDrag
          (cdkDragStarted)="dragStart(workOrder, $event)"
          (cdkDragEnded)="dragEnd(workOrder)"
          [cdkDragDisabled]="shouldDisableWODrag(workOrder)"
          [shouldShowLeftColor]="shouldShowLeftColor"
          [shouldShowRightColor]="shouldShowRightColor"
          [canDrag]="canDrag"
        ></app-wellness-work-order-card>
      }
    }
    <!--
    @if (filteredWellnessWorkOrders.length > 30 && !showAllWellness) {
       <div class="regular-link p-col-12 center" (click)="showAllWellness = true">+ SHOW ALL +</div> 
    }
    @if (filteredWellnessWorkOrders.length > 30 && showAllWellness) {
       <div class="regular-link p-col-12 center" (click)="showAllWellness = false">+ SHOW LESS +</div>
    } -->
  </div>
}

@if (isTreeWorkOnly) {
  <div
    class="p-grid"
    id="workOrdersPanelList"
    cdkDropList
    [cdkDropListDisabled]="!canDrag"
    [cdkDropListData]="filteredWorkWorkOrders"
    [cdkDropListConnectedTo]="dragAndDropService.allCDKWorkOrderListIds"
    (cdkDropListDropped)="drop($event)"
    cdkDropListSortingDisabled="true">
    @if (isLoadingWOs) {
      <div>
        <i class="pi pi-spin pi-spinner" style="font-size: 3em"></i>
      </div>
    }
    @if (!isLoadingWOs && filteredWorkWorkOrders.length == 0) {
      <div>
        No tree work work orders to schedule at this time.
      </div>
    }
    @for (workOrder of filteredWorkWorkOrders; track workOrder; let i = $index) {
      @if (i < 30 || showAllWork) {
        <app-work-work-order-card
          [ngClass]="{'custom-p-col-lg p-md-4 p-sm-6': selectedView == 'day', 'p-col-12': selectedView == 'week'}"
          [workOrder]="workOrder"
          [showScheduled]="false"
          (dragStartEvent)="taskDragged($event)"
          (taskDragEndEvent)="taskDragEnd()"
          cdkDrag
          (cdkDragStarted)="dragStart(workOrder, $event)"
          (cdkDragEnded)="dragEnd(workOrder)"
          [cdkDragDisabled]="shouldDisableWODrag(workOrder)"
          [shouldShowLeftColor]="shouldShowLeftColor"
          [shouldShowRightColor]="shouldShowRightColor"
          [canDrag]="canDrag"
        ></app-work-work-order-card>
      }
  }
    <!--
    @if (filteredWorkWorkOrders.length > 30 && !showAllWork) {
      <div class="regular-link p-col-12 center" (click)="showAllWork = true">+ SHOW ALL +</div>
    }
     @if (filteredWorkWorkOrders.length > 30 && showAllWork) {
      <div class="regular-link p-col-12 center" (click)="showAllWork = false">+ SHOW LESS +</div>
    } -->
  </div>
}